export interface CombatVoiceCue { url: string; strength: number; priority: number; factionId?: string; pan?: number }

const VOICE_GAP_SECONDS = .18;
const UNKNOWN_CLIP_SECONDS = 1.2;

/** One best-effort bark channel per faction: cues compete within a faction, and requests during playback are discarded. */
export class CombatVoiceChannel {
  private busyUntil = new Map<string, number>();
  constructor(
    private readonly play: (url: string, strength: number, pan?: number) => void,
    private readonly duration: (url: string) => number,
    private readonly now: () => number = () => performance.now() / 1000,
  ) {}

  playOne(cues: readonly CombatVoiceCue[]): boolean {
    const now = this.now();
    const byFaction = new Map<string, CombatVoiceCue[]>();
    for (const cue of cues) {
      const factionId = cue.factionId ?? 'hostiles';
      const factionCues = byFaction.get(factionId) ?? [];
      factionCues.push(cue);
      byFaction.set(factionId, factionCues);
    }
    let played = false;
    for (const [factionId, factionCues] of byFaction) {
      if (now < (this.busyUntil.get(factionId) ?? 0)) continue;
      const cue = factionCues.reduce((best, current) => current.priority > best.priority ? current : best);
      this.play(cue.url, cue.strength, cue.pan ?? 0);
      this.busyUntil.set(factionId, now + (this.duration(cue.url) || UNKNOWN_CLIP_SECONDS) + VOICE_GAP_SECONDS);
      played = true;
    }
    return played;
  }
}
